import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditHotelExtra from "../../components/hotelExtras/FormAddEditHotelExtra";
import useGetHotelExtra from "../../hooks/hotelExtras/useGetHotelExtra";
import { CircularProgress, Box } from "@mui/material";

const EditHotelExtra = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { isLoading, hotelExtra } = useGetHotelExtra(id);

    if (isLoading) {
        return (
            <WrapperSection>
                <Box display="flex" justifyContent="center" p={4}>
                    <CircularProgress />
                </Box>
            </WrapperSection>
        );
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditHotelExtra
                isEdit={true}
                currentData={hotelExtra}
                onSubmitSuccess={() => navigate("/hotel-extras")}
            />
        </WrapperSection>
    );
};

export default EditHotelExtra;
